<ui-m030-c110-model-hero
    [image]="model().heroImage"
    [title]="model().alternativeModelDetailName ?? 'Hyundai ' + model().name"
    [text]="dealerLocationHeadline()"
    [logoImages]="model().logoImages"
    [isAvailable]="model().teaserVehicles.length > 0"
    [isDigital]="!model().modelAnnouncementCampaign"
    [envkv]="{ model: model().name, envkv: model().envkv, score: model().co2Class }"
    isFirstView
/>
@if (firstCampaignWithMinimumShortTitle()) {
    <a
        ui-m040-c040-promotion-banner
        class="lg:order-2"
        [hyundaiRouterLink]="firstCampaignWithMinimumShortTitle()?.detailUrl"
        isFirstView
    >
        {{ firstCampaignWithMinimumShortTitle()?.content?.minimumShortTitle }}
    </a>
}
@if (model().modelAnnouncementCampaign; as campaign) {
    <section>
        <ui-m040-c045-offer-banner
            [data]="campaign.showroomButtons"
            [ctaLink]="'tel:' + dealer().phone"
            [ctaSubText]="dealer().phone"
            [link]="model().disableTestdrive ? model().offerUrl : model().testDriveUrl"
            [primaryButton]="model().disableTestdrive ? model().offerUrl : model().testDriveUrl"
            [showOnlyPrimaryButton]="showOnlyPrimaryButton()"
            [ctaText]="model().disableTestdrive ? 'Jetzt beraten lassen' : 'Jetzt Probefahrt vereinbaren'"
            [primaryButtonText]="model().disableTestdrive ? 'Angebot anfragen' : 'Probefahrt vereinbaren'"
            (primaryButtonClicked)="
                tracking.trackButton({
                    elType: 'button',
                    event: 'engagement_click',
                    elLabel: 'Test Drive',
                    elTarget: model().disableTestdrive ? model().offerUrl : model().testDriveUrl,
                })
            "
            (linkClicked)="
                tracking.trackButton({
                    elType: 'button',
                    event: 'engagement_click',
                    elLabel: 'Test Drive',
                    elTarget: model().disableTestdrive ? model().offerUrl : model().testDriveUrl,
                })
            "
            (ctaClicked)="
                tracking.trackButton({
                    elType: 'button',
                    event: 'engagement_click',
                    elLabel: 'Test Drive',
                    elTarget: 'tel:' + dealer().phone,
                })
            "
            linkText="Terminvereinbarung"
        />

        @if (model().heroImageCaption; as caption) {
            <span class="absolute -bottom-0 translate-y-full px-12 py-5" [innerHTML]="caption"></span>
        }
    </section>
    <ng-container [ngTemplateOutlet]="heroImageCaption" />

    <ng-container [ngTemplateOutlet]="similarVehicles" />

    @if (campaign.leasingExample) {
        <section class="flex justify-center bg-grey-100">
            <ui-m060-c020-vehicle-leasing-example
                class="block w-full"
                [headline]="'Musterangebot'"
                [image]="campaign.heroImage"
                [text]="'für Ihr Hyundai Kilometer Leasing¹'"
                [tableHeadline]="campaign.leasingExample.tableHeadline"
                [tableHeadlineValue]="campaign.leasingExample.tableHeadlineValue"
                [tableData]="campaign.leasingExample.tableData"
                [link]="model().offerUrl"
                [linkText]="'Angebot erhalten'"
                [isFirstView]="true"
                [removeMobileImage]="campaign"
            />
        </section>
    }
} @else {
    <ng-container [ngTemplateOutlet]="heroImageCaption" />

    <ui-m040-c120-contact-model-banner
        [ctaLink]="'tel:' + dealer().phone"
        [ctaSubText]="dealer().phone"
        [link]="model().disableTestdrive ? model().offerUrl : model().testDriveUrl"
        [primaryButton]="model().disableTestdrive ? model().offerUrl : model().testDriveUrl"
        [showOnlyPrimaryButton]="showOnlyPrimaryButton()"
        [ctaText]="model().disableTestdrive ? 'Jetzt beraten lassen' : 'Jetzt Probefahrt vereinbaren'"
        [primaryButtonText]="model().disableTestdrive ? 'Angebot anfragen' : 'Probefahrt vereinbaren'"
        [linkText]="model().disableTestdrive ? 'Angebot anfragen' : 'Probefahrt vereinbaren'"
        (primaryButtonClicked)="
            tracking.trackButton({
                elType: 'button',
                event: 'engagement_click',
                elLabel: 'Test Drive',
                elTarget: model().disableTestdrive ? model().offerUrl : model().testDriveUrl,
            })
        "
        (linkClicked)="
            tracking.trackButton({
                elType: 'button',
                event: 'engagement_click',
                elLabel: 'Test Drive',
                elTarget: model().disableTestdrive ? model().offerUrl : model().testDriveUrl,
            })
        "
        (ctaClicked)="
            tracking.trackButton({
                elType: 'button',
                event: 'engagement_click',
                elLabel: 'Test Drive',
                elTarget: 'tel:' + dealer().phone,
            })
        "
    >
        <h2 class="text-wrap" headline>
            Den {{ testDriveModelName() }} {{ model().disableTestdrive ? 'kennenlernen' : 'probefahren' }}.
        </h2>
        <p class="text-wrap" subheadline>
            @if (model().disableTestdrive) {
                Wir beraten Sie zum {{ testDriveModelName() }} bei uns in {{ dealer().city }}.
            } @else {
                Erleben Sie den {{ testDriveModelName() }} live bei uns in {{ dealer().city }}.
            }
        </p>
    </ui-m040-c120-contact-model-banner>

    <ng-container [ngTemplateOutlet]="similarVehicles" />

    <section class="bg-grey-100">
        <div class="inner-page-wrapper-px-0 grid grid-cols-1 divide-x divide-grey-500 md:grid-cols-2">
            <div
                class="flex flex-grow flex-col items-start justify-between gap-16 bg-white px-24 pb-64 pt-40 md:my-40 md:gap-24 md:bg-transparent md:py-40 md:pl-0 md:pr-[55px] lg:pr-[79px]"
            >
                <div>
                    <h2
                        class="leading-29 flex items-start gap-4 font-headline text-24 font-medium text-black md:gap-8 md:text-34 md:leading-41"
                    >
                        <span>Weitere attraktive Angebote</span>
                    </h2>
                    <p class="mt-12 text-16 leading-27 text-black">
                        Sie interessieren sich für eine bestimmte Ausstattungsvariante oder haben besondere Wünsche? Wir
                        erstellen Ihnen gerne ein individuelles Angebot.
                    </p>
                </div>
                <a
                    class="button-primary md:w-auto"
                    [trackingElTarget]="model().offerUrl"
                    [href]="model().offerUrl"
                    trackingElType="button"
                    tracking
                    trackingEvent="engagement_click"
                    trackingElLabel="Offer Request"
                    target="_blank"
                >
                    Angebot anfragen
                </a>
            </div>
            <div
                class="flex flex-grow scroll-mt-[90px] flex-col items-start justify-between gap-16 px-24 pb-64 pt-40 md:my-40 md:gap-24 md:py-40 md:pl-[55px] md:pr-0 lg:pl-[79px]"
                id="digital-erleben"
            >
                <div>
                    <h2
                        class="leading-29 flex items-start gap-4 font-headline text-24 font-medium text-black md:gap-8 md:text-34 md:leading-41"
                    >
                        <i class="icon-smartphone-car text-40 text-black"></i>

                        <span>Online-Beratung</span>
                    </h2>
                    <p class="mt-12 text-16 leading-27 text-black">
                        Unsere Berater unterstützen Sie auch gerne online – kompetent und individuell. Der Hyundai
                        Online-Showroom ist für Sie täglich von 10 bis 22 Uhr (nationale Feiertage ausgeschlossen)
                        geöffnet.
                    </p>
                </div>
                @defer (on viewport) {
                    <button
                        ui-m010-c020-icon-link
                        class="mx-auto block md:mx-0 md:py-12"
                        showroomBtn
                        tracking
                        trackingEvent="engagement_click"
                        trackingElType="button"
                        trackingElTarget="PopUp"
                        trackingElLabel="Digital Showroom"
                    >
                        Zum digitalen Showroom
                    </button>
                } @placeholder {
                    <button
                        ui-m010-c020-icon-link
                        class="mx-auto block md:mx-0 md:py-12"
                        tracking
                        trackingEvent="engagement_click"
                        trackingElType="button"
                        trackingElTarget="PopUp"
                        trackingElLabel="Digital Showroom"
                    >
                        Zum digitalen Showroom
                    </button>
                }
            </div>
        </div>
    </section>
}

<section>
    <div class="md:min-h-[400px]">
        @defer {
            <ui-m030-c090-gallery
                class="block md:pt-64"
                [images]="model().contentImages"
                [caption]="model().contentImagesCaption ?? undefined"
                [isFirstView]="false"
            />
        }
    </div>

    <ui-m030-c100-big-short-facts
        [facts]="model().keyFacts"
        [externalLink]="model().cwModelUrl"
        [link]="model().disableTestdrive ? model().offerUrl : model().testDriveUrl"
        [ctaLink]="'tel:' + dealer().phone"
        [ctaSubText]="dealer().phone"
        [primaryButton]="model().disableTestdrive ? model().offerUrl : model().testDriveUrl"
        [showOnlyPrimaryButton]="showOnlyPrimaryButton()"
        [ctaText]="model().disableTestdrive ? 'Jetzt beraten lassen' : 'Jetzt Probefahrt vereinbaren'"
        [primaryButtonText]="model().disableTestdrive ? 'Angebot anfragen' : 'Probefahrt vereinbaren'"
        [linkText]="model().disableTestdrive ? 'Angebot anfragen' : 'Probefahrt vereinbaren'"
        (primaryButtonClicked)="
            tracking.trackButton({
                elType: 'button',
                event: 'engagement_click',
                elLabel: 'Test Drive',
                elTarget: model().disableTestdrive ? model().offerUrl : model().testDriveUrl,
            })
        "
        (linkClicked)="
            tracking.trackButton({
                elType: 'button',
                event: 'engagement_click',
                elLabel: 'Test Drive',
                elTarget: model().disableTestdrive ? model().offerUrl : model().testDriveUrl,
            })
        "
        (ctaClicked)="
            tracking.trackButton({
                elType: 'button',
                event: 'engagement_click',
                elLabel: 'Test Drive',
                elTarget: 'tel:' + dealer().phone,
            })
        "
        externalLinkText="Mehr zum Model auf Hyundai.de"
    >
        @let contentHeadline = model().contentHeadline || '' | footnotes;
        <h2 [innerHTML]="contentHeadline()" headline></h2>
        @if (model().contentCopy?.html) {
            <div text>
                @let contentCopy = model().contentCopy?.html || '' | footnotes;
                <div [innerHTML]="contentCopy()"></div>
            </div>
        }
    </ui-m030-c100-big-short-facts>
</section>

@defer (on idle) {
    <app-global-contact isFirstView="false" />

    @if (model().modelAnnouncementCampaign; as campaign) {
        @if (campaign.warrantyLogo1 || campaign.warrantyLogo2 || campaign.warrantyLogo3) {
            <ui-m040-c015-warrenty-footer-logos
                [logos]="[campaign?.warrantyLogo1, campaign?.warrantyLogo2, campaign?.warrantyLogo3]"
            />
        }
    }

    @if (model().legalTexts; as legalTexts) {
        <ui-m040-c020-rte [data]="legalTexts.html" />
    }
}

<ng-template #heroImageCaption>
    <div class="inner-page-wrapper relative">
        @if (model().heroImageCaption; as caption) {
            <span class="leading-21 absolute top-0 py-5 text-14 text-grey-400" [innerHTML]="caption"></span>
        }
    </div>
</ng-template>

<ng-template #similarVehicles>
    <lib-similar-vehicles [similarVehicles]="model().teaserVehicles" title="Top Angebote aus unserem Sortiment">
        <a
            class="button-primary mx-auto mt-[88px] w-max"
            [hyundaiRouterLink]="dealer().pages.vehiclemarket"
            [queryParams]="
                model().vehicleMarketFilterParams
                    ? {
                          filter: model().vehicleMarketFilterParams ?? '',
                      }
                    : undefined
            "
            link
        >
            Zum Fahrzeugbestand
        </a>
    </lib-similar-vehicles>
</ng-template>
